/**
 * RESPONSIBILITY: one of the pictures the home page shows behind its title.
 *
 * A row rather than a bare list of images, so a picture can carry its own description for a
 * screen reader - the @Img value already holds one.
 */
import { Row, Img } from '@framework/core/decorators';
import type { ImageValue } from '@framework/core';

@Row()
export class HeroStill {
  @Img({
    label: 'Large picture', folder: 'home', maxSizeMb: 12, size: '1920 × 1080',
  })
  image!: ImageValue;
}
